import { useSelector } from "react-redux";


function RedirectURLObject({ type = "cart", redirectTo = false }) {
    if (typeof redirectTo == "string") {
        if (redirectTo.indexOf("no_referrer=1") === false) {
            if (redirectTo.indexOf("?") > 0) {
                redirectTo += "&no_referrer=1"
            } else {
                redirectTo += "?no_referrer=1"
            }
        }
    }
    const loginUrl = useSelector(state => state.user.paths.login_url);
    const baseProtocol = useSelector(state => state.user.paths.base_protocol);
    const baseTanantUrl = useSelector(state => state.user.paths.tenant_domain);
    const isGuestEnabled = useSelector(state => state.user.miscellaneous.guest_checkout);
    const isLoggedIn = useSelector(state => state.user.user.is_logged_in);
    const signUrl = `${baseProtocol}${baseTanantUrl}`;
    if (type === "login") {
        return {isReact:false, url:loginUrl + (redirectTo ? redirectTo : "/dashboard")};
    }
    if (type === "signup") {
        return {isReact:false, url:signUrl + (redirectTo ? redirectTo : "/register")};
    }
    switch (type) {
        case "cart":
            redirectTo = redirectTo ? redirectTo : "/cart_react";
            return isGuestEnabled ? {isReact:true, url:"/cart_react"} : (isLoggedIn ? {isReact:true, url:"/cart_react"} : {isReact:false, url:loginUrl + redirectTo});
        case "buy_now":
            redirectTo = redirectTo ? redirectTo : "/cart_react";
            return isGuestEnabled ? {isReact:true, url:redirectTo} : (isLoggedIn ? {isReact:true, url:redirectTo} : {isReact:false, url:loginUrl + redirectTo});
        case "enroll_now":
            redirectTo = redirectTo ? redirectTo : "/course/listing";
            return isGuestEnabled ? {isReact:true, url:redirectTo} : (isLoggedIn ? {isReact:true, url:redirectTo} : {isReact:false, url:loginUrl + redirectTo});
        default:
            return "/";
    }
}
export default RedirectURLObject;